import styles from './template.css';
import template from './template';
import {AoflElement, customElement, property} from '@aofl/element';
import {mapStatePropertiesMixin} from '@aofl/map-state-properties-mixin';
import {storeInstance} from '@aofl/store/dist/legacy';
import {sdoNs} from '../constants-enumerate';
import '../session-sdo';
import {hasOneOfPermissions} from '../permissions';

/**
 * @summary AuthContext
 * @extends {mapStatePropertiesMixin(AoflElement)}
 */
@customElement('auth-context')
class AuthContext extends mapStatePropertiesMixin(AoflElement) {
  /**
   * Creates an instance of AuthContext.
   */
  constructor() {
    super();

    this.storeInstance = storeInstance;
  }

  /**
   * @readonly
   */
  static is = 'auth-context';

  @property({type: Boolean})
  ['show-on-auth'] = false;

  @property({type: Boolean, attribute: false, mapState: `${sdoNs.SESSION}.loggedIn`, store: storeInstance})
  loggedIn = false;

  @property({type: Array, attribute: false})
  permissions = null;

  @property({type: Array, attribute: true})
  restricted = null;

  @property({type: String})
  ['hide-user-type'] = null;

  @property({type: Boolean, attribute: false, mapState: `${sdoNs.SESSION}.type`, store: storeInstance})
  userType = false;

  @property({type: Boolean})
  permitted = true;

  permissionsChanged = () => {
    if (this.permissions !== null) { // eslint-disable-line
      this.permitted = hasOneOfPermissions(this.permissions); // eslint-disable-line
    }
    if (this.permitted && this.restricted !== null && hasOneOfPermissions(this.restricted)) {
      this.permitted = false;
    }
  }

  connectedCallback() {
    super.connectedCallback();

    if (this.permissions && !Array.isArray(this.permissions)) {
      console.error('auth-context permissions must be passed in as an array', this.permissions);
    }
    if (this.restricted && !Array.isArray(this.restricted)) {
      console.error('auth-context restricted permissions must be passed in as an array', this.restricted);
    }

    window.addEventListener('permissions-updated', this.permissionsChanged);
  }

  shouldUpdate(changedProperties) {
    if (changedProperties.has('permissions')) {
      this.permissionsChanged();
    }

    return true;
  }
  /**
   *
   * @return {Object}
   */
  render() {
    return super.render(template, [styles]);
  }
  disconnectedCallback() {
    window.removeEventListener('permissions-updated', this.permissionsChanged);

    super.disconnectedCallback();
  }
}

export default AuthContext;
